import { withErrorBoundary } from "@sentry/nextjs";
import { FC, HTMLAttributes } from "react";
import { Markdown, ArrowLink } from "components";
import { IntroductionBusinessSectionContent, IntroductionIndividualSectionContent } from "types/graphql/generated";

interface Props {
  className?: HTMLAttributes<HTMLDivElement>["className"];
  link:
    | IntroductionBusinessSectionContent["linkOne"]
    | IntroductionBusinessSectionContent["linkTwo"]
    | IntroductionIndividualSectionContent["link"];
  label:
    | IntroductionBusinessSectionContent["linkLabelOne"]
    | IntroductionBusinessSectionContent["linkLabelTwo"]
    | IntroductionIndividualSectionContent["linkLabel"];
  description:
    | IntroductionBusinessSectionContent["descriptionOne"]
    | IntroductionBusinessSectionContent["descriptionTwo"]
    | IntroductionIndividualSectionContent["description"];
}

const Item: FC<Props> = withErrorBoundary(({ className = "", link, label, description }) => {
  return (
    <div className={className}>
      <ArrowLink href={link} className="mb-2 text-lg font-semibold text-fog-80 md:text-2xl">
        {label}
      </ArrowLink>
      <Markdown className="text-base text-fog-60 md:text-lg">{description}</Markdown>
    </div>
  );
}, {});

export { Item };
